// @flow
/*!
 * engine-blackjack
 * Copyright(c) 2016 Marco Casula
 * GPL 2.0 Licensed
 */

export const INVALID: string = 'INVALID'
export const RESTORE: string = 'RESTORE'
export const DEAL: string = 'DEAL'
export const INSURANCE: string = 'INSURANCE'
export const SPLIT: string = 'SPLIT'
export const HIT: string = 'HIT'
export const DOUBLE: string = 'DOUBLE'
export const STAND: string = 'STAND'
export const SURRENDER: string = 'SURRENDER'
export const SHOWDOWN: string = 'SHOWDOWN'
export const DEALER_HIT: string = 'DEALER-HIT'
export const RIGHT: string = 'right'
export const LEFT: string = 'left'
export const STAGE_READY: string = 'ready'
export const STAGE_PLAYER_TURN_RIGHT: string = 'player-turn-right'
export const STAGE_PLAYER_TURN_LEFT: string = 'player-turn-left'
export const STAGE_SHOWDOWN: string = 'showdown'
export const STAGE_DEALER_TURN: string = 'dealer-turn'
export const STAGE_DONE: string = 'done'



// WEBPACK FOOTER //
// ./src/constants.js